import { updates } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6">
          最新动态
        </h2>
        <div className="relative pl-6 border-l-2 border-primary-200">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="relative pb-6 last:pb-0 group"
            >
              <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform duration-200"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                <span className="text-xs text-foreground-400 whitespace-nowrap font-medium">{item.time}</span>
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap ${
                  item.tag === '热播' || item.tag === '热门' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '重磅' ? 'bg-accent-100 text-accent-700' :
                  item.tag === '完结' ? 'bg-secondary-100 text-secondary-700' :
                  'bg-background-200 text-foreground-600'
                }`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-700 mt-1.5 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}